






	// @ts-ignore
    import _ from './CActiveListItem.ts'; export default _;
